import { config } from '../config';

export const apiUrl = config.APIURL
// xport const apiUrl = process.env.REACT_APP_APIURL